export default "__VITE_ASSET__BVsWlaWF__"